import {MouseEventHandler} from 'react';
import {twMerge} from '../../../../common/twMerge';
import {Icon} from '../../../atoms/Icon/Icon';
import {IconType} from '../../../atoms/Icon/IconType.enum';
import {Image} from '../../../atoms/Image/Image';
import {Text} from '../../../atoms/Text/Text';

export interface CharactersProps {
  expand: boolean;
  onClickExpand: MouseEventHandler;
  isMobile: boolean;
  characters: Array<{
    thumbnail?: string;
    name?: string;
    description?: string;
  }>;
}

export function Characters({
  characters,
  expand,
  isMobile,
  onClickExpand,
  ...props
}: CharactersProps) {
  const shouldShowMoreButton = !expand && characters.length > 2;

  const mobileBlurColor = 'var(--colors-theme-solid-10)';
  const desktopBlurColor = 'var(--colors-theme-bg-surface-alt)';

  return (
    <div
      className={twMerge(
        'relative flex w-full flex-col px-18pxr pb-10pxr',
        shouldShowMoreButton && 'cursor-pointer'
      )}
      onClick={shouldShowMoreButton ? onClickExpand : undefined}
      {...props}
    >
      {characters.map(({thumbnail, name, description}, index) => {
        if (shouldShowMoreButton && index > 1) {
          return;
        }

        return (
          <div
            key={`character-${index}-${name}`}
            className={twMerge(
              'mt-10pxr flex w-full flex-col',
              (!shouldShowMoreButton || index === 0) && 'mb-20pxr'
            )}
          >
            {thumbnail && (
              <div className="mb-12pxr h-90pxr w-90pxr overflow-hidden rounded-8pxr">
                <Image
                  alt={name ?? '캐릭터 썸네일'}
                  src={thumbnail}
                  className="h-full w-full"
                  ratio={1}
                />
              </div>
            )}
            <div className="flex w-full flex-col px-6pxr">
              <Text className="font-medium1-bold mr-56pxr mb-4pxr text-theme-solid-100">
                {name}
              </Text>
              <div className="relative flex">
                <Text className="font-small1 whitespace-pre-line text-theme-solid-60">
                  {description}
                </Text>
                {shouldShowMoreButton && index === 1 && (
                  <div
                    className="absolute top-0 left-0 h-full w-full"
                    style={{
                      background: isMobile
                        ? `linear-gradient(180deg,
                            rgb(${mobileBlurColor} / 0%) 0%,
                            rgb(${mobileBlurColor} / 0%) 50%,
                            rgb(${mobileBlurColor} / 90%) 100%)`
                        : `linear-gradient(180deg,
                            rgb(${desktopBlurColor} / 0%) 0%,
                            rgb(${desktopBlurColor} / 0%) 50%,
                            rgb(${desktopBlurColor} / 90%) 100%)`,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      })}
      {shouldShowMoreButton && (
        <div className="flex h-12pxr w-full items-center justify-center">
          <Icon type={IconType.ContentHomeArrowDown} />
        </div>
      )}
    </div>
  );
}
